const form_data = {
    agree_to_privacy_policy: "",
    payment_method: "",
    payment_frequency: "",
    payment_type: "",
    amount: "",
    no_of_child: 1,
    partner_id: "",
    number_counter: 1
}

const site_options = {
    "form_heading": "Donation Form",
    "default_payment_method": "",
    "default_payment_type": "",
    "form_type": "standard",
    "form_template": "default",
    "form_position": "left",
    "form_background_image":"",
    "form_background_text": `<h1>Through your <span className="orange-txt-bg">sponsorship,</span> you are helping a child, a family, and a community.</h1>`,
    "min_onetime_amount": "",
    "min_recurring_amount": "",
    "base_recurring_amount": "",
    "base_onetime_amount": "",
    "amount_options_onetime": [],
    "amount_options_recurring": [],
    "payment_methods": [],
    "payment_types": [],
    "team": "Online Marketing Team",
    "fields": [],
    "donor": [],
    "child_counter":0,
    "form_mode":'light-mode',
    "amount_suffix_type": "default", //default, text-only, number-with-text
    "amount_suffix_divisor": 0,
    "amount_suffix_text": "one-time",
    "form_content_heading": "",
    "form_content_body": "",
    "other_amount_onetime": 1,
    "other_amount_recurring": 1,
    "amount_addons_onetime": [],
    "amount_addons_recurring": []
}

const google_analytics = {
    ga_client_id: '1914666454.1674648667',
    utmString:'utm_source:=www.worldvision.org.ph',
}

const store = {
    form_data,
    google_analytics,
    site_options
}

export default store